import React from "react";
import "../css/privacy.scss";
import PolicyPage from "./PolicyPage";

function Faq() {
  return (
    <PolicyPage title="Frequently Asked Questions">
      <h2>How do I choose a size?</h2>
      <p>Use the US size selector shown on each product page and compare your foot length with the fit notes. If you are between sizes or plan to wear thick socks, email core@danecay.shop before ordering.</p>
      <h2>Are the shoes made from genuine leather?</h2>
      <p>The material for each style is listed on its product page. Genuine leather naturally varies in grain, tone and creasing, so small differences between pairs are expected.</p>
      <h2>How much is shipping?</h2>
      <p>Shipping is USD 9.99 per order. The charge appears separately in the cart and checkout total.</p>
      <h2>When will my order arrive?</h2>
      <p>Preparation normally takes 2–5 business days, followed by an estimated 5–15 business days in transit. Carrier disruptions can affect the estimate.</p>
      <h2>Can I change my delivery address?</h2>
      <p>Email us immediately. We will try to update the order before dispatch, but changes cannot be guaranteed once the carrier has received the parcel.</p>
      <h2>How do returns work?</h2>
      <p>Request a return within 14 days after delivery. Shoes must remain unworn outdoors and in original condition. Read the Returns & Refunds page before sending a parcel.</p>
      <h2>How do I care for leather shoes?</h2>
      <p>Wipe them with a soft dry cloth, allow moisture to dry naturally away from heat, use a suitable neutral conditioner sparingly and store the pair in a ventilated place.</p>
      <h2>How can I contact danecay?</h2>
      <p>Email <a href="mailto:core@danecay.shop">core@danecay.shop</a>. We normally reply within two business days, Monday to Friday, Hong Kong time.</p>
    </PolicyPage>
  );
}

export default Faq;
